import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Paper,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import NavbarBack from './NavbarBack';

function UserNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNotif, setSelectedNotif] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const userId = localStorage.getItem('userId');
        const username = localStorage.getItem('username');
        const recipientId = userId || username;

        if (!recipientId) {
          setNotifications([]);
          setLoading(false);
          return;
        }

        const response = await fetch(`https://reviewhub-lc.onrender.com/api/notification/${recipientId}`);
        const data = await response.json();
        setNotifications(data || []);
      } catch (error) {
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

const handleNotificationClick = async (notif) => {
  if (notif.link) {
    try {
      await fetch(`https://reviewhub-lc.onrender.com/api/notification/mark-read/${notif._id}`, {
        method: 'PATCH',
      });

      setTimeout(() => {
        navigate(0); // reload to refresh list
      }, 300);
    } catch (err) {
      console.error('Error marking notification as read:', err);
    }

    navigate(notif.link);
  }
};

  const handleMenuClick = (event, notif) => {
    setAnchorEl(event.currentTarget);
    setSelectedNotif(notif);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedNotif(null);
  };

  const handleDelete = async () => {
    if (!selectedNotif) return;
    
    try {
      const response = await fetch(`https://reviewhub-lc.onrender.com/api/notification/${selectedNotif._id}`, {
        method: 'DELETE',
      });
      
      if (response.ok) {
        setNotifications(notifications.filter(notif => notif._id !== selectedNotif._id));
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
    } finally {
      handleMenuClose();
    }
  };

  if (loading) {
    return (
      <Box p={3} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <NavbarBack title="Notifications" />
      <Box p={3}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Notifications
        </Typography>
        <Paper elevation={2}>
          <List>
            {notifications.length > 0 ? (
              notifications.map((notif) => (
                <React.Fragment key={notif._id}>
                  <ListItem
                    sx={{
                      backgroundColor: notif.isRead ? 'inherit' : '#e3f2fd',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box 
                      sx={{ flexGrow: 1 }} 
                      onClick={() => handleNotificationClick(notif)}
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            sx={{ fontWeight: notif.isRead ? 'normal' : 'bold' }}
                          >
                            {notif.message}
                          </Typography>
                        }
                        secondary={new Date(notif.createdAt).toLocaleString()}
                      />
                    </Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="notification-menu"
                      aria-haspopup="true"
                      onClick={(e) => handleMenuClick(e, notif)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))
            ) : (
              <ListItem>
                <ListItemText primary="No notifications available." />
              </ListItem>
            )}
          </List>
        </Paper>
      </Box>

      {/* Menu for delete option */}
      <Menu
        id="notification-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </>
  );
}

export default UserNotifications;